export default class ForbiddenError extends Error {
  private previous?: Error;

  constructor(message: string | null, previous?: Error) {
    super(message ?? 'Forbidden access');

    this.name = 'ForbiddenError';
    this.previous = previous;
  }
}
